import React, {useMemo} from 'react';
import '../style/Section2.scss';
import SectionTitle from "../components/SectionTitle";
import section2Img from "../assets/images/pc/01_tokenomics.png";
import section2ImgMobile from "../assets/images/mobile/01_Tokenomics.png"

import useWindowDimensions from "../util/Utils";
function Section2(props) {
  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => {
    return width <= 780;
  }, [width]);

  return (
      <div id={'Section2'}>
        <SectionTitle title={'TOKENOMICS'}/>
        <div className="content-wrapper">
          <img src={isMobile ? section2ImgMobile:section2Img} alt="" className="section-img"/>
        </div>
        <div className="section-description">
          <div className="description-row">
            Our token disbursement curve is uniquely designed, with the majority of the 1 billion tokens released at the end of a 20-year cycle to smooth out inflation. Most tokens are allocated to validators as staking rewards, similar to how Bitcoin incentivizes miners. In a Proof of Stake blockchain, validator yield is crucial for securing the network. This curve ensures a mostly constant yield over the 20-year period while maintaining a low circulating supply.
          </div>
          <div className="description-row">Investor and team allocations are modest. Early investors faced a long lockup period, while subsequent investors have a 12-month lockup followed by an 18-month vesting period. The team is subject to an 18-month lockup with an 18-month vesting period.</div>
          <div className="description-row bold">
            <strong>Transaction Fee Distribution:</strong>
          </div>
          <div className="description-row">
            Transaction fees are distributed to non-validating <strong>nodes, wallets, and smart contracts.</strong> Setting up a node is accessible to anyone, requiring only a Raspberry Pi. This approach broadens participation, drives token price momentum, and cultivates a dedicated, cult-like following.
          </div>
        </div>
      </div>
  );
}

export default Section2;